<template>
	<md-field :class="[{ 'md-error': error }]">
		<label>{{ labelText }}</label>
		<TbSelect
			v-model="moduleValue"
			@md-selected="onSelect"
			:search-allow="true"
			:options="options"
			options-value-field="id"
			:options-display-getter="(item) => $t(item.translationKey)"
			:no-entries-text="!country ? $t('common.select.countryRequired') : ''"
			content-size="xl"
			:disabled="disabled"
			:required="required"
		/>
		<span v-if="error" class="validation-error">{{ error }}</span>
	</md-field>
</template>
<script>
import {commonApi} from "@/common/api/commonApi";

export default {
	name: "register-select",
	props: {
		country: [String, Number],
		labelText: { type: String, default: "value" },
		disabled: { type: Boolean, default: false },
		isError: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		error: { type: Boolean, default: "" },
		value: { type: String, default: "" }
	},
	data() {
		return {
			moduleValue: "",
			options: []
		};
	},
	mounted() {
		this.getList();
		this.moduleValue = this.value;
	},
	computed: {
		selectedOption() {
			return this.options.find(option => option.id === this.moduleValue)
		}
	},
	methods: {
		onSelect() {
			this.$emit("input", this.moduleValue);
		},
		getList() {
			let { country } = this;
			if (!country) {
				this.options = [];
				this.value = "";
				return;
			}

			commonApi
				.Registercourts(country)
				.then(res => {
					if (res) {
						this.options = res;

						if (this.isValueInOptions(this.value)) {
							this.moduleValue = this.value;
						} else {
							// This is typically the case when the country changed
							this.moduleValue = null;
						}

						this.$emit("ready", this.moduleValue);
					}
				});
		},
		isValueInOptions(value) {
			return this.options.find(item => item.id === value) !== undefined;
		},
		doesSelectedRequireDocument() {
			return this.selectedOption ? this.selectedOption.requiresRegistrationDocument : false;
		},
		doesSelectedRequireRegistrationNumber() {
			return this.selectedOption ? this.selectedOption.requiresRegistrationNumber : false;
		},
		getRequiredDocumentNameKeyForSelected() {
			return this.selectedOption ? this.selectedOption.registrationDocumentNameKey : null;
		}
	},
	watch: {
		country() {
			this.getList();
		},
		value() {
			this.moduleValue = this.value;
		}
	}
};
</script>
